import { useSelector } from "react-redux";

import AutoSubmissionSettings from "./AutoSubmissionSettings";

import { AUTO_SUBMISSION_PAGES, getAvailableOs } from "./constants";

const AutoSubmissionBody = ({ selectedItem }) => {
  const vms = useSelector((state) => state.dashboard.vms);

  const page = AUTO_SUBMISSION_PAGES.find((entry) => entry.label === selectedItem);
  const submitType = (page || AUTO_SUBMISSION_PAGES[0]).submitType;

  if (!getAvailableOs(vms).length) {
    return (
      <p className="auto-submission-no-vm">
        Currently there is no available machine, click on check vms button to check available
        machines.
      </p>
    );
  }

  return (
    <div className="auto-submission-body">
      <AutoSubmissionSettings key={submitType} submitType={submitType} />
    </div>
  );
};

export default AutoSubmissionBody;
